import styled from 'styled-components'

export const PopoverContainer = styled.div`
  position: relative;
  opacity: 0;
  pointer-events: none;
  transition: .3s;

  &.active {
    opacity: 1;
    pointer-events: all;
  }

  .arrowBox {
    position: absolute;
    z-index: 9;
    background: ${props => props.type === 'warning' ? 'var(--mystic)' : 'var(--danger)'};
    border: 4px solid ${props => props.type === 'warning' ? 'var(--mystic)' : 'var(--danger)'};
    color: ${props => props.type === 'warning' ? 'var(--text)' : 'var(--white)'};
    border-radius: 15px;

    width: 100%;
    padding: 12px 27px;

    font-family: 'Nunito', sans-serif;
    font-size: 10px;
    line-height: 1.2;

    strong {
      font-family: 'Nunito', sans-serif;
      font-weight: 700;
    }

    &:after,
    &:before {
      position: absolute;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      pointer-events: none;
    }
  }

  .arrowBoxTop {
    top: 0;
    right: 0;

    strong {
      font-size: 12px;
    }

    &:after,
    &:before {
      top: 100%;
      left: 50%;
    }

    &:after {
      border-color: rgba(242, 69, 61, 0);
      border-top-color: ${props => props.type === 'warning' ? 'var(--mystic)' : 'var(--danger)'};
      border-width: 22px;
      margin-left: 25px;
    }

    &:before {
      border-color: rgba(242, 69, 61, 0);
      border-top-color: ${props => props.type === 'warning' ? 'var(--mystic)' : 'var(--danger)'};
      border-width: 22px;
      margin-left: 25px;
    }
  }

  .arrowBoxBottom {
    top: 0;
    left: 0;

    strong {
      font-size: 11px;
    }

    &:after,
    &:before {
      bottom: 100%;
      left: 50%;
    }

    &:after {
      border-color: rgba(242, 69, 61, 0);
      border-bottom-color: ${props => props.type === 'warning' ? 'var(--mystic)' : 'var(--danger)'};
      border-width: 22px;
      margin-left: -80px;
    }

    &:before {
      border-color: rgba(242, 69, 61, 0);
      border-bottom-color: ${props => props.type === 'warning' ? 'var(--mystic)' : 'var(--danger)'};
      border-width: 22px;
      margin-left: -80px;
    }
  }
`
